// eslint-disable-next-line no-unused-vars
let savedViewContainerObj = JSON.parse(localStorage.getItem("savedViewContainer"));


var StateData = {

  selectFilterValue: "all",
  value: 0,
  objectAllFilterArray: [
    { "name": "102-Decatur AL", "value": "102", catName: "Facility", catShortName:"FA" },
    { "name": "Retail", "value": "Retail", catName: "Bpcategory", catShortName: "CC" },
    { "name": "KAG Food Products", "value": "KAG Food Products", catName: "Customer name", catShortName: "Cu" },
    { "name": "Accessorial (FoodGrade)", "value": "Accessorial (FoodGrade)", catName: "Product category", catShortName: "PC" },
    { "name": "Work Order", "value": "Work Order", catName: "Document type", catShortName: "DOC" },
    { "name": "Kosher Caustic Wash", "value": "Kosher Caustic Wash", catName: "Service plan", catShortName: "SP" }],

  selectedAllValue: [],

  objectAllFAArray: [
    { "name": "102-Decatur AL", "value": "102", catName: "Facility", catShortName: "FA" },
    { "name": "101-Sidney OH", "value": "101", catName: "Facility", catShortName: "FA" },
  ],

  objectAllCuArray: [
    { "name": "Bohman Trucking Inc.", "value": "Bohman Trucking Inc.", catName: "Customer name", catShortName: "Cu" },
    { "name": "Caledonia Haulers", "value": "Caledonia Haulers", catName: "Customer name", catShortName: "Cu" },
    { "name": "Derrick Wolfe Trucking", "value": "Derrick Wolfe Trucking", catName: "Customer name", catShortName: "Cu" },
    { "name": "DFA Dairy Brands", "value": "DFA Dairy Brands", catName: "Customer name", catShortName: "Cu" },
    { "name": "Foodliner Inc.", "value": "Foodliner Inc.", catName: "Customer name", catShortName: "Cu" },
    { "name": "Hilltop", "value": "Hilltop", catName: "Customer name", catShortName: "Cu" },
    { "name": "Hoffman Transportation LLC", "value": "Hoffman Transportation LLC", catName: "Customer name", catShortName: "Cu" },
    { "name": "IST Logistics", "value": "IST Logistics", catName: "Customer name", catShortName: "Cu" },
    { "name": "Johnsrud Transport Inc.", "value": "Johnsrud Transport Inc.", catName: "Customer name", catShortName: "Cu" },
    { "name": "KAG Food Products", "value": "KAG Food Products", catName: "Customer name", catShortName: "Cu" },
    { "name": "Larger Brothers", "value": "Larger Brothers", catName: "Customer name", catShortName: "Cu" },
    { "name": "Leeper Trucking LLC", "value": "Leeper Trucking LLC", catName: "Customer name", catShortName: "Cu" },
    { "name": "Norris", "value": "Norris", catName: "Customer name", catShortName: "Cu" },
    { "name": "Pence\u0027s Milk Transport", "value": "Pence\u0027s Milk Transport", catName: "Customer name", catShortName: "Cu" },
    { "name": "Prime Inc.", "value": "Prime Inc.", catName: "Customer name", catShortName: "Cu" },
    { "name": "Rodel Trucking", "value": "Rodel Trucking", catName: "Customer name", catShortName: "Cu" },
    { "name": "Savannah Classic Food", "value": "Savannah Classic Food", catName: "Customer name", catShortName: "Cu" },
    { "name": "Store & Haul Inc. Trucking", "value": "Store & Haul Inc. Trucking", catName: "Customer name", catShortName: "Cu" },
    { "name": "Trimac", "value": "Trimac", catName: "Customer name", catShortName: "Cu" },
    { "name": "Viessman Trucking", "value": "Viessman Trucking", catName: "Customer name", catShortName: "Cu" },
  ],

  objectAllCCArray: [
    { "name": "Retail", "value": "Retail", catName: "Bpcategory", catShortName: "CC" },
    { "name": "Hoffman Transportion LLC", "value": "Hoffman Transportion LLC", catName: "Bpcategory", catShortName: "CC" },
  ],

  objectAllSPArray: [
    { name: "Chocolate Kosher Wash", value: "Chocolate Kosher Wash", catName: "Service plan", catShortName: "SP" },
    { name: "Double Kosher Caustic Wash", value: "Double Kosher Caustic Wash", catName: "Service plan", catShortName: "SP" },
    { name: "Food Grade Steam per Customer Requirements", value: "Food Grade Steam per Customer Requirements", catName: "Service plan", catShortName: "SP" },
    { name: "IMS Dairy Wash", value: "IMS Dairy Wash", catName: "Service plan", catShortName: "SP" },
    { name: "Kosher Caustic Wash", value: "Kosher Caustic Wash", catName: "Service plan", catShortName: "SP" },
    { name: "Kosher Detergent Wash", value: "Kosher Detergent Wash", catName: "Service plan", catShortName: "SP" },
    { name: "Kosher Type 5 Food Grade Wash", value: "Kosher Type 5 Food Grade Wash", catName: "Service plan", catShortName: "SP" },
    { name: "Sweetener Liquid Wash", value: "Sweetener Liquid Wash", catName: "Service plan", catShortName: "SP" },
    { name: "Wax Kosher Wash", value: "Wax Kosher Wash", catName: "Service plan", catShortName: "SP" },
  ],

  objectAllDOCArray: [
    { name: "Work Order", value: "Work Order", catName: "Document type", catShortName: "DOC" },
  ],

  objectAllPCArray: [
    { name: "Accessorial (FoodGrade)", value: "Accessorial (FoodGrade)", catName: "Product category", catShortName: "PC" },
    { name: "Heel (FoodGrade)", value: "Heel (FoodGrade)", catName: "Product category", catShortName: "PC" },
  ],

  objectAllLBArray: [
    { "name": "Tank", "value": "Tank", catName: "Line of business", catShortName: "LB" },
  ],


  loading: false,
  visible: true,
  isTourOpen: false,
  showSavedViews: false,
  showFilters: true,
  showHideOverAllFilters: true,
  showCreateSavedView: false,
  editMode: false,
  filterId: "",
  filterName: "",
  filterDescription: "",
  storedFilters: savedViewContainerObj,
  filtersTitleName: "Filters",
  displayFilterValue: "workorders",
  optionsForTimeFilter: [
    { name: "Work Order Start Date", value: "WorkOrder.start_date" },
    { name: "Work Order End Date", value: "WorkOrder.enddate" },
  ],
  optionsForDateRange: [
    { name: "All time", value: undefined },
    { name: "Today", value: "today" },
    { name: "Yesterday", value: "Yesterday" },
    { name: "This week", value: "This week" },
    { name: "This month", value: "This month" },
    { name: "This quarter", value: "This quarter" },
    { name: "This year", value: "This year" },
    { name: "Last 30 days", value: "Last 30 days" },
    { name: "Last week", value: "Last week" },
    { name: "Last month", value: "Last month" },
    { name: "Last quarter", value: "Last quarter" },
    { name: "Last year", value: "Last year" },
  ],
  optionsForGranularityList: [
    { name: "w/o time slice", value: null },
    { name: "Hour", value: "hour" },
    { name: "Day", value: "day" },
    { name: "Week", value: "week" },
    { name: "Month", value: "month" },
    { name: "Year", value: "year" }
  ],
  optionsForWidgetLimit: [
    { name: "All", value: "1000" },
    { name: "1", value: "1" },
    { name: "2", value: "2" },
    { name: "3", value: "3" },
    { name: "4", value: "4" },
    { name: "5", value: "5" }
  ],
  facilityList: [],
  bPCategoryList: [],
  bpNameList: [],
  lineOfBusinessList: [],
  productCategoryList: [],
  doctypeList: [],
  serviceList: [],
  timeDimension: "WorkOrder.enddate",
  dateRangeList: "This year",
  granularityList: null,
  limitInWidget: 1000,

  selectedFacilityValue: [],
  selectedValueBPCategory: [],
  selectedValueBPName: [],
  selectedValueLineOfBusiness: [],
  selectedValueProductCategory: [],
  selectedValueDoctype: [],
  selectedServiceValue: [],
  selectedTimeFilterValue: [{ name: "Work Order End Date", value: "WorkOrder.enddate" }],
  selectedDateRangeList: [{ name: "This year", value: "This year" }],
  selectedGranularityList: [{ name: "w/o time slice", value: "w/o grouping" }]
};


module.exports = StateData;
